import axios from "axios";
import { SUBSCRIPTION_ENDPOINTS, API_BASE_URL } from "../constants/apis";
import tokenRefreshService from "./tokenRefresh";

// Payment service for starting subscriptions
class PaymentService {
    constructor() {
        this.baseURL = API_BASE_URL;
    }

    // Start free plan
    async startFreePlan(captchaToken = null) {
        try {
            const token = await tokenRefreshService.getValidToken();
            const headers = {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            };

            const payload = {
                plan_name: "FREE",
                currency: "INR"
            };

            // Include captcha token if provided
            if (captchaToken) {
                payload.captcha_token = captchaToken;
            }

            const response = await axios.post(
                `${this.baseURL}${SUBSCRIPTION_ENDPOINTS.PAYMENT}`,
                payload,
                { headers }
            );
            return response.data;
        } catch (error) {
            console.error('Error starting free plan:', error);
            throw error;
        }
    }
}

// Create singleton instance
const paymentService = new PaymentService();

export default paymentService;

